interface IServices {
  id: string;
  url: (val: string) => string;
}

export const services: IServices[] = [
  {
    id: "youtube",
    url: (videoId: string) => `https://www.youtube.com/embed/${videoId}`,
  },
  {
    id: "instagram",
    url: (videoId: string) => `https://instagram.com/p/${videoId}/embed`,
  }
];
